/* asc-pdp-creators.js — creator wall: drift only while on screen, pause button, tap-to-play dialog (native <dialog>). */
(function () {
  function init(root) {
    if (root.__ascCw) return; root.__ascCw = true;
    var dlg = root.querySelector('[data-asc-cw-dlg]');
    var vid = dlg.querySelector('video');
    var img = dlg.querySelector('.asc-cw__img');
    var cap = dlg.querySelector('.asc-cw__cap');
    var closeBtn = dlg.querySelector('[data-asc-cw-close]');
    var pause = root.querySelector('[data-asc-cw-pause]');
    var opener = null;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { root.classList.toggle('is-on', e.isIntersecting); }); }, { rootMargin: '100px 0px' }).observe(root);
    } else root.classList.add('is-on');

    if (pause) pause.addEventListener('click', function () {
      var p = root.classList.toggle('is-paused');
      pause.setAttribute('aria-pressed', p ? 'true' : 'false');
      pause.setAttribute('aria-label', p ? (pause.dataset.playLabel || 'Play the moving desks') : (pause.dataset.pauseLabel || 'Pause the moving desks'));
    });

    function stop() { try { vid.pause(); } catch (e) {} vid.removeAttribute('src'); vid.load(); vid.hidden = true; img.hidden = true; img.removeAttribute('src'); }
    function close() { if (dlg.open) dlg.close(); }
    dlg.addEventListener('close', function () {
      stop(); root.classList.remove('is-open'); document.documentElement.style.overflow = '';
      if (opener && document.contains(opener)) { try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); } }
    });
    closeBtn.addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target === dlg.firstElementChild) close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = [closeBtn]; if (!vid.hidden) f.push(vid);
      var i = f.indexOf(document.activeElement);
      e.preventDefault();
      f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
    });

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-asc-cw-open]');
      if (!t || !root.contains(t)) return;
      opener = t.closest('[data-clone]') ? null : t;
      var h = t.getAttribute('data-handle') || '';
      cap.textContent = '@' + h;
      if (t.dataset.video) {
        vid.hidden = false; vid.poster = t.dataset.img || '';
        vid.setAttribute('aria-label', t.getAttribute('aria-label') || '');
        vid.src = t.dataset.video;
      } else {
        img.hidden = false; img.src = t.dataset.img || ''; img.alt = (t.getAttribute('aria-label') || '').replace(/^\S+\s/, '');
      }
      root.classList.add('is-open');
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
      closeBtn.focus();
      if (t.dataset.video) {
        var p = vid.play();
        if (p && p.catch) p.catch(function () { vid.muted = true; var q = vid.play(); if (q && q.catch) q.catch(function () {}); });
      }
    });
  }
  function boot() { document.querySelectorAll('[data-asc-cw]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
